import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { AlertTriangle, Home, RefreshCcw } from 'lucide-react';

export default function ErrorBoundary() {
  const error = useRouteError();
  
  let errorMessage = 'An unexpected error occurred.';
  let errorStatus = 500;

  if (isRouteErrorResponse(error)) {
    errorStatus = error.status;
    errorMessage = error.statusText || error.data?.message || errorMessage;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-neutral-50 dark:bg-neutral-950">
      <div className="max-w-md w-full bg-white dark:bg-neutral-900 rounded-[2.5rem] border border-neutral-200 dark:border-neutral-800 p-10 shadow-xl shadow-neutral-200/50 text-center space-y-6">
        <div className="w-20 h-20 bg-rose-50 dark:bg-rose-950/40 rounded-3xl flex items-center justify-center mx-auto text-rose-500 dark:text-rose-400">
          <AlertTriangle className="w-10 h-10" />
        </div>
        
        <div className="space-y-2">
          <h1 className="text-4xl font-black tracking-tight text-neutral-900 dark:text-neutral-50">{errorStatus}</h1>
          <h2 className="text-xl font-bold text-neutral-800">Oops! Something went wrong</h2>
          <p className="text-neutral-500 dark:text-neutral-400 text-sm leading-relaxed">
            {errorMessage}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 pt-4">
          <button 
            onClick={() => window.location.reload()}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-neutral-100 dark:bg-neutral-800 rounded-2xl text-sm font-bold text-neutral-600 dark:text-neutral-300 hover:bg-neutral-200 dark:hover:bg-neutral-800 transition-all"
          >
            <RefreshCcw className="w-4 h-4" />
            Retry
          </button>
          <Link 
            to="/app"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-neutral-900 rounded-2xl text-sm font-bold text-white hover:bg-neutral-800 transition-all shadow-lg shadow-neutral-900/20"
          >
            <Home className="w-4 h-4" />
            Home
          </Link>
        </div>
        
        <p className="text-[10px] font-bold text-neutral-300 uppercase tracking-widest pt-4">
          Messego Error System
        </p>
      </div>
    </div>
  );
}
